import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { PartyPopper, Trophy, ChevronRight } from "lucide-react";

function Option({ icon: Icon, title, sub, onClick, testid, color }) {
  return (
    <button onClick={onClick} className="w-full flex items-center gap-4 rounded-2xl border border-white/10 bg-muted/40 p-4 press text-left" data-testid={testid}>
      <div className={`h-12 w-12 rounded-full grid place-items-center ${color}`}><Icon className="w-6 h-6" /></div>
      <div className="flex-1"><div className="font-bold text-base">{title}</div><div className="text-xs text-muted-foreground">{sub}</div></div>
      <ChevronRight className="w-5 h-5 text-muted-foreground" />
    </button>
  );
}

export default function CreateChooser({ onClose, onPick }) {
  return (
    <Sheet open onOpenChange={(o) => { if (!o) onClose(); }}>
      <SheetContent side="bottom" className="rounded-t-3xl bg-card border-t border-white/10 pb-10" data-testid="create-chooser">
        <SheetHeader className="text-left mb-4"><SheetTitle className="text-2xl heading font-extrabold">O que você quer criar?</SheetTitle></SheetHeader>
        <div className="space-y-3">
          <Option icon={PartyPopper} title="Criar rolê" sub="Churras, resenha, festa, show..." onClick={() => onPick("event")} testid="choose-create-event" color="bg-primary text-primary-foreground" />
          <Option icon={Trophy} title="Fechar time" sub="Chame a galera pra completar o jogo" onClick={() => onPick("game")} testid="choose-create-game" color="bg-emerald-500 text-black" />
        </div>
      </SheetContent>
    </Sheet>
  );
}
